import { useEffect, useState } from 'react';
import { useIndexedDB } from 'react-indexed-db-hook';
import { useSelector } from 'react-redux';

export const useGetDownloadedAvatar = () => {
  const [downloadedAvatar, setDownloadedAvatar] = useState(null);
  const { getAll } = useIndexedDB('image');
  const { avatar } = useSelector((state) => state.authSlice);

  useEffect(() => {
    const getDownloadedAvatar = async () => {
      try {
        const allImages = await getAll();
        const avatarURL = localStorage.getItem('avatarURL') || avatar;
        const avatarFromDB = allImages.find((img) => img.url === avatarURL);
        setDownloadedAvatar(URL.createObjectURL(avatarFromDB?.file));
      } catch {
        // console.log('avatar error');
      }
    };
    if (!downloadedAvatar) getDownloadedAvatar();
  }, [!downloadedAvatar]);
  return downloadedAvatar;
};
